import * as Yup from 'yup'

export const initialValues = {
    password: '',
    password_confirmation: '',
}

export const validationSchema = Yup.object().shape({
    password: Yup.string()
        .required('Password is required')
        .min(6, 'Password minimum is 6 characters'),
    password_confirmation: Yup.string()
        .required('Password is required')
        .oneOf([Yup.ref('password')], 'Your passwords do not match.'),
})
